import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import "../../../_assets/css/custom.css";
import "react-owl-carousel2/lib/styles.css";
import { postMethod } from "../../../_services/_postMethod";
import AddProduct from "../branch/products/addproduct";
import Button from "@material-ui/core/Button";
import Snackbar from "@material-ui/core/Snackbar";
import { API_BASE_URL } from "../../../_services/constant";
import OwlCarousel from "react-owl-carousel2";
import Slide from "@material-ui/core/Slide";
import CustomerHeader from "./components/header";
import CustomerFooter from "./components/footer";
import CustomerBanner from "./components/banner";
import CustomerVoucherCom from "./components/voucher";
import { Backdrop, CircularProgress, makeStyles } from "@material-ui/core";
import { size } from "lodash";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#000",
    backgroundColor: "#fff",
  },
  productCard: {
    borderRadius: '16px',
    background: 'rgba(255, 255, 255, 0.7)',
    backdropFilter: 'blur(10px)',
    border: '1px solid rgba(255, 255, 255, 0.3)',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.05)',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    cursor: 'pointer',
    '&:hover': {
      transform: 'translateY(-6px)',
      boxShadow: '0 12px 48px rgba(0, 0, 0, 0.12)',
    }
  },
  imageContainer: {
    position: 'relative',
    width: '100%',
    paddingTop: '100%',
    overflow: 'hidden',
    backgroundColor: '#f8f9fa',
  },
  cardImage: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    transition: 'transform 0.5s ease',
  },
  cardContent: {
    padding: '12px',
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  productTitle: {
    fontSize: '0.9rem',
    fontWeight: 600,
    color: '#1a1a1a',
    fontFamily: '"Inter", sans-serif',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textDecoration: 'none',
    margin: 0,
  },
  metaText: {
    fontSize: '0.75rem',
    color: '#888',
  },
  priceRow: {
    display: 'flex',
    alignItems: 'baseline',
    gap: '6px',
    marginTop: '4px',
    flexWrap: 'wrap',
  },
  currentPrice: {
    fontSize: '1rem',
    fontWeight: 700,
    color: '#000',
  },
  originalPrice: {
    fontSize: '0.82rem',
    color: '#888',
    textDecoration: 'line-through',
  },
}));

const CustomerProductview = (props) => {
  const classes = useStyles();
  const { register, handleSubmit, errors } = useForm();
  const [isvalid, setValid] = useState(false);
  const [load, setLoad] = useState(false);
  const inputRef = React.createRef(null);
  const [voucherList, setVoucherList] = useState([]);
  const [snackbarMsg, setSnackbarMsg] = useState("");
  const [products, setProducts] = useState([]);

  const [productCount, setProductCount] = React.useState(0);
  const [product, setProduct] = useState([
    {
      product_id: "",
      product_code: "",
      Metal: "",
      discounted_price: "",
      price: "",
      product_name: "",
      remarks: "",
      weight: "",
      trial: "",
      size_length: "",
      available: false,
    },
  ]);
  const [productImages, setProductImages] = useState([]);
  const [productImage, setProductImage] = useState("");

  const normalizeColor = (c) => {
    if (!c) return 'transparent';
    const str = String(c).trim();
    const lower = str.toLowerCase();
    const map = {
      'navy blue': 'navy',
      'light blue': 'lightblue',
      'dark blue': 'darkblue',
      'rose gold': '#b76e79',
      'yellow gold': '#ffd700',
      'white gold': '#e5e4e2',
    };
    if (map[lower]) return map[lower];
    const parts = lower.split(/\s+/);
    return parts[parts.length - 1];
  };

  const optionsSimilar = {
    responsive: {
      0: {
        items: 2,
      },
      600: {
        items: 2,
      },
      1000: {
        items: 4,
      },
    },
    dots: false,
    margin: 20,
    autoplay: false,
    // center:true,
    stagePadding: 10,
    loop: false,
    nav: false,
  };
  const optionsProduct = {
    responsive: {
      0: {
        items: 1,
        margin: 10,
      },
      600: {
        items: 1,
        margin: 10,
      },
      1000: {
        items: 1,
        margin: 10,
      },
    },
    dots: false,
    autoplay: false,
    center: true,
    stagePadding: 10,
    loop: true,
    nav: true,
  };

  const [open, setOpen] = React.useState(false);

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const AddProductList = (type) => {
    postMethod("api/session/add_to_cart", {
      product_id: product.product_id,
      price: product.discounted_price,
      added_from: "customized",
      type: type,
    }).then((data) => {
      if (type == "wish") {
        setSnackbarMsg(
          "Product added to wish list. Customer executive will contact you soon."
        );
      } else {
        setSnackbarMsg(
          "Product added to trial. Customer executive will contact you soon."
        );
      }
      handleClick();
      postMethod("api/session/wishlist", {}).then((data) => {
        setProductCount(data.data.length);
      });
    });
  };

  useEffect(() => {
    setLoad(true);
    postMethod("api/session/products_view", {
      product_id: localStorage.getItem("product_id"),
    }).then((dataD) => {
      var data = dataD.data;
      console.log(data[0][0]);
      setProduct(data[0][0]);
      setProductImage(data[1][0].image_path);
      setProductImages(data[1]);
      postMethod("api/session/similar_products", {
        category_id: localStorage.getItem("category_id"),
        min_price: 0,
        max_price: data[0][0].price,
        metal: data[0][0].Metal,
        material: data[0][0].material,
        subcategory_id: "0",
        skip: "0",
      }).then((data) => {
        var result = data.data.filter((item) => item.product_id != localStorage.getItem("product_id"));
        setProducts(result);
      });


      setLoad(false);
    });
  }, []);

  const RedirectToProduct = (product_id) => {
    window.scrollTo(0, 0);
    localStorage.setItem("product_id", product_id);
    window.location.reload();
  };

  return (
    <React.Fragment>
      <Backdrop className={classes.backdrop} open={load}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <div>
        <Snackbar
          open={open}
          autoHideDuration={5000}
          onClose={handleClose}
          message={snackbarMsg}
        />
      </div>
      <CustomerHeader count={productCount} />
      <div className="clr"></div>
      <div className="container-fluid toppadhead">
        <div className="row toppad5 mtoppad2">
          <div className="container">
            <div className="catsectionbx">
              <div className="row no-gutters">
                <div className="col-md-2 d-none d-md-block col-lg-1 order-2 order-md-1">
                  <div className="thumbnail">
                    <ul className="list-unstyled p-0 d-flex d-md-block flex-wrap mt-3 mt-md-0">
                      {productImages.length > 0
                        ? productImages.map((pr, index) => {
                          if (index < 4) {
                            return (
                              <li key={index}>
                                <div className="thumb shadow-sm">
                                  <img
                                    src={
                                      pr?.isImageUrl
                                        ? pr.image_path
                                        : `${API_BASE_URL}Images/${pr?.image_path || ""}`
                                    }
                                    onClick={() => {
                                      if (window.outerWidth > 600) {
                                        setProductImage(pr.image_path);
                                      } else {
                                        console.log(inputRef.current);
                                        inputRef.current.goTo(3);
                                      }
                                    }}
                                    className="w-100"
                                  />
                                </div>
                              </li>
                            );
                          }
                        })
                        : null}
                    </ul>
                  </div>
                </div>
                <div className="col-md-10 col-lg-6 d-none d-lg-block d-md-block order-1 text-md-center text-lg-left order-md-2">

                  <img
                    style={{ height: 400, width: 423 }}
                    src={
                      productImages?.[0]?.isImageUrl
                        ? productImages[0].image_path
                        : `${API_BASE_URL}Images/${productImages?.[0]?.image_path || ""}`
                    }
                  />
                </div>
                <div className="col-sm-5 d-none d-lg-none d-md-none d-block productSlide">
                  {productImages.length && (
                    <div className="productSlides">
                      <OwlCarousel ref={inputRef} options={optionsProduct}>

                        {productImages.map((prop, i) => (
                          <img
                            src={
                              prop?.isImageUrl
                                ? prop.image_path
                                : `${API_BASE_URL}Images/${prop?.image_path || ""}`}
                            style={{ width: "100%", height: 350, objectFit: 'contain' }}
                            className="img-fluid "
                            alt=""
                          />
                        ))}
                      </OwlCarousel>
                    </div>
                  )}
                </div>
                <div className="col-md-12 col-lg-5 prv mtoppad3 order-3 order-md-3">
                  <div className="mtoppad2">
                    <i className="fa fa-star text-warning"></i>
                    <i className="fa fa-star text-warning"></i>
                    <i className="fa fa-star text-warning"></i>
                    <i className="fa fa-star text-warning"></i>
                    <i className="fa fa-star text-warning"></i>
                  </div>
                  <h2 className="toppad1">
                    {product.product_name}
                    <span className="ml-2">
                      <a href="#section2">Product Details</a>
                    </span>
                  </h2>
                  <p>{product.remarks}</p>
                  {(localStorage.getItem("jwl_hide_price") == 'false' || localStorage.getItem("jwl_hide_price") == false) ?
                    <div className="price">
                      {product.discounted_price !== 0 &&
                        product.discounted_price !== null &&
                        product.discounted_price !== undefined ? (
                        <>
                          ₹ {product.discounted_price}{" "}
                          <span className="greytxt lpadd1">
                            <del>₹ {product.price}</del>
                          </span>
                        </>
                      ) : (
                        <>₹ {product.price}</>
                      )}
                    </div> : null
                  }


                  <div className="product-available">
                    <span>Availability :- </span>
                    {product.on_demand == "In stock" ? (
                      <span style={{ color: "#46a506" }}>In Stock</span>
                    ) : (
                      <span style={{ color: "#f15d47" }}>Make to Order </span>
                    )}
                  </div>
                  <div className="row toppad5">
                    {/* <div className="col-6 col-sm-6 col-lg-4 btnpad">
                      <div className="form-group">
                        <label for="inputState">Metal</label>
                        <select
                          id="inputState"
                          className="form-control"
                          disabled={true}
                        >
                          <option selected> {product.Metal}</option>
                        </select>
                      </div>
                    </div> */}
                    <div className="col-6 col-sm-6 col-lg-4 btnpad">
                      <div className="form-group">
                        <label for="inputState">Material</label>
                        <select
                          id="inputState"
                          className="form-control"
                          disabled={true}
                        >
                          <option selected>{product.material}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="row toppad5 mtoppad2 wishBtn">
                    {product.trial == true ? (
                      <>
                        <div className="col-6 col-sm-6 col-lg-4 btnpad">
                          <button
                            className="allbtn"
                            type="button"
                            onClick={() => AddProductList("wish")}
                          >
                            Add to Wish List
                          </button>
                        </div>
                        <div className="col-6 col-sm-6 col-lg-4 btnpad">
                          <button
                            className="trybtn"
                            type="button"
                            onClick={() => AddProductList("trial")}
                          >
                            Try Before you Buy
                          </button>
                        </div>
                      </>
                    ) : (
                      <div className="col-12 col-sm-12 col-lg-8 btnpad">
                        <button
                          className="allbtn"
                          type="button"
                          onClick={() => AddProductList("wish")}
                        >
                          Add to Wish List
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="clr"></div>
      <div className="container-fluid py-5" id="section2">
        <div className="container prvdtl">
          <div className="row">
            <div className="col-12">
              <h3>Product Details</h3>
            </div>
            <div className="col-12 col-sm-12 col-lg-4">
              <ul className="p-0">
                <li>
                  <b>Product code:</b> {product.product_code}
                </li>
                {
                  product.Metal ?
                    <li>
                      <b>Metal</b> - {product.Metal}
                    </li> : null
                }
                {
                  product.package ?
                    <li>
                      <b>Package</b> - {product.package}
                    </li> : null
                }
                {
                  product.ptype ?
                    <li>
                      <b>Product Type</b> - {product.ptype}
                    </li> : null
                }
                {
                  product.pattern ?
                    <li>
                      <b>Pattern</b> - {product.pattern}
                    </li> : null
                }
                {
                  product.size_length ?
                    <li>
                      <b>Size</b> - {product.size_length}
                    </li> : null
                }
                {
                  product.color ?
                    <li>
                      <b>Color</b> - {product.color}
                    </li> : null
                }
                <li>
                  <b>Metal</b> - {product.Metal}
                </li>
                <li>
                  <b>Material</b> - {product.material}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      {products && products.length > 0 ? (
        <section className="similarProducts bg-light py-5">
          <div className="container">
            <div className="uniq">
              <h2 className="text-left">Similar Products</h2>
            </div>
            <OwlCarousel ref={inputRef} options={optionsSimilar}>
              {products &&
                products.map((prop, i) => (
                  <div
                    key={"product" + i}
                    className={classes.productCard}
                    onClick={() => RedirectToProduct(prop.product_id)}
                  >
                    <div className={classes.imageContainer}>
                      <img
                        className={classes.cardImage}
                        src={
                          prop?.isImageUrl
                            ? prop.image_path
                            : `${API_BASE_URL}Images/${prop?.image_path || ""}`
                        }
                        style={{ objectFit: "contain" }}
                        alt={prop.product_name}
                      />
                    </div>
                    <div className={classes.cardContent}>
                      <div className={classes.productTitle} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{prop.product_name}</span>
                        {(prop.color || prop.Color) && (
                          <span
                            title={prop.color || prop.Color}
                            style={{
                              width: '14px',
                              height: '14px',
                              borderRadius: '50%',
                              backgroundColor: normalizeColor(prop.color || prop.Color),
                              border: '1px solid rgba(0,0,0,0.15)',
                              display: 'inline-block',
                              flexShrink: 0,
                              marginLeft: '8px',
                            }}
                          />
                        )}
                      </div>
                      {prop.size_length && (
                        <span className={classes.metaText}>
                          Size: <strong style={{ color: '#555' }}>{prop.size_length}</strong>
                        </span>
                      )}
                      {(localStorage.getItem("jwl_hide_price") === 'false' || localStorage.getItem("jwl_hide_price") == false) && (
                        <div className={classes.priceRow}>
                          {prop.discounted_price != 0 && prop.discounted_price ? (
                            <>
                              <span className={classes.currentPrice}>₹ {prop.discounted_price}</span>
                              <span className={classes.originalPrice}>₹ {prop.price}</span>
                            </>
                          ) : (
                            <span className={classes.currentPrice}>₹ {prop.price}</span>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                ))}
            </OwlCarousel>
          </div>
        </section>
      ) : null}

      {/* <div className="  toppad3 botmargn3 slideVoucher pb-10 mb-6 mb-md-0 "> */}

      {/* <div className=" mt-4 mb-5 mb-md-4 px-0"> */}
      {/* <CustomerVoucherCom/> */}
      {/* </div> */}
      {/* </div> */}
      <CustomerFooter />
    </React.Fragment>
  );
};

export default CustomerProductview;
